export const thresholdDesc =
  "Configure thresholds to be applied for generating alerts. The same threshold will be used across all " +
  "segments unless a segment-specific override is configured.";
